/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Offers_Sessions_Per_PeriodInputs */

const en_offers_sessions_per_period = /** @type {(inputs: Offers_Sessions_Per_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} sessions each period`)
};

const pl_offers_sessions_per_period = /** @type {(inputs: Offers_Sessions_Per_PeriodInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} wejść w każdym okresie`)
};

/**
* | output |
* | --- |
* | "{count} sessions each period" |
*
* @param {Offers_Sessions_Per_PeriodInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const offers_sessions_per_period = /** @type {((inputs: Offers_Sessions_Per_PeriodInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offers_Sessions_Per_PeriodInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_offers_sessions_per_period(inputs)
	return en_offers_sessions_per_period(inputs)
});